module.exports = __webpack_public_path__ + "static/img/sjbanner2.6508d68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/sjbanner2.jpg
// module id = 6M68
// module chunks = 1